<template>
  <div class="d-flex align-center">
    <v-text-field
      ref="filterTextField"
      v-model="filterText"
      outlined
      hide-details
      :placeholder="localPlaceholder"
      :label="$t('TaskList.Filter')"
      class="mr-2"
    />
    <v-btn
      color="primary"
      @click="search"
    >
      {{ $t('PublicServant.Action.Search') }}
    </v-btn>
  </div>
</template>
<script>

export default {
  props: {
    placeholder: {
      type: String,
      default: null
    },
    filterTextProp: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      filterText: ''
    }
  },
  computed: {
    localPlaceholder () {
      return this.placeholder ? this.placeholder : this.$t('TaskList.FilterPlaceholder')
    }
  },
  watch: {
    filterTextProp: {
      handler: function (val) {
        this.filterText = val
      },
      immediate: true
    }
  },
  methods: {
    search: function () {
      this.$emit('search', this.filterText)
    },
    focus: function () {
      this.$refs.filterTextField.focus()
    },
    clear: function () {
      this.filterText = ''
    }
  }
}
</script>
